import React from "react";
import SmallDialog from "src/SharedComponents/SmallDialog/SmallDialog";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";
import { LicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import UnassignLicenseInstructions from "./UnassignLicenseInstructions";
import { useTranslation } from "react-i18next";

interface IUnassignLicenseFromClinic{
    entitlementId: string;
    distributorId: string;
    clinicId: string;
    clinicName: string;
    closeDialog: () => void;
}

const UnassignLicenseFromClinic: React.FC<IUnassignLicenseFromClinic> = ({entitlementId,distributorId, clinicId, closeDialog, clinicName}) => {
    const { unassignLicenseClinic } = useDistributorLicenseServiceWrapper();
    const {t} = useTranslation();

    return(
        <>
            <SmallDialog
                submitButtonText={t('Ok')}
                title={t('UnassigningLicense')}
                onClose={() => { closeDialog() }}
                onSubmit={() => {
                    unassignLicenseClinic(LicenseType.AuraAppLicenses, clinicId, entitlementId, clinicName, distributorId);
                }} >
                    <UnassignLicenseInstructions entitlementId={entitlementId} />
            </SmallDialog>
        </>
    );
}

export default React.memo(UnassignLicenseFromClinic);